import { createAction } from "@logicsoftware/redux-toolkit";
import { UserInfo } from "../../EasyProjects/ActivityList/Cache/UsersCache";

export const userInvited = createAction<UserInfo>("USER_INVITE/USER_INVITED");
